import dedent from 'ts-dedent'
import {
  ColumnDataType,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class CountRows extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.count',
        group: 'Aggregation',
        title: 'Count',
        description: `
      This component counts the number of rows of the input table.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */ COUNT(*) count
              FROM ${connection.quoteName(params.source as string)}`
    } else {
      return dedent`SELECT COUNT(*) count
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema(): TableSchema {
    return [
      {
        name: 'count',
        type: ColumnDataType.Number
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest
    ]
  }
}

export { CountRows }
